@if (title()) {
<label>{{title()}}</label>
}
<ace [useAceClass]="true" [mode]="'json'" [theme]="'monokai'" [value]="control().value ?? ''"
  (valueChange)="onChange($event)" />
@if (control().invalid) {
<mat-error class="schema-form-initial-font-field">
  {{getErrorMessage()}}
</mat-error>
}